import { useCallback, useMemo } from 'react'
import { useClinic } from '@/lib/clinic/store'
import { formatCurrency, formatPhone } from '@/lib/format'
import { getInvoiceByVisit, getVisitStatsByPatient, indexById } from '@/lib/clinic/selectors'

// Formats an amount in the clinic's billing currency.
export const useMoney = (): ((amount: number) => string) => {
    const { data } = useClinic()
    const currency = data.settings.billing.currency
    return useCallback((amount: number) => formatCurrency(amount, currency), [currency])
}

// Formats a stored 10 digit number with the clinic's WhatsApp country code.
export const usePhoneFormatter = (): ((phone: string) => string) => {
    const { data } = useClinic()
    const code = data.settings.whatsapp.countryCode
    return useCallback((phone: string) => formatPhone(phone, code), [code])
}

// Lookup maps shared by most screens.
export const useLookups = () => {
    const { data } = useClinic()
    const patientsById = useMemo(() => indexById(data.patients), [data.patients])
    const treatmentsById = useMemo(() => indexById(data.treatments), [data.treatments])
    const visitStats = useMemo(() => getVisitStatsByPatient(data.visits), [data.visits])
    const invoiceByVisit = useMemo(() => getInvoiceByVisit(data.invoices), [data.invoices])
    return { patientsById, treatmentsById, visitStats, invoiceByVisit }
}
